













































import {Vue, Component} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import dataProxy from "@/services/data-proxy.service";
import {Nedelja, Period} from "@/services/BackendProxies";
import {formatDate} from "@/utils/formatters";

@Component({})
export default class PregledReferentnihPerioda extends mixins(ComponentBaseMixin) {
    periodi = [];
    tableOptions = {
        search: true,
        pagination: true,
        headerStyle: () => {return {css: {'font-size': '9px'}}}
    };
    columns = [];
    mesecnoRV = [];
    izabraniPeriod: number = null;
    osobaId: number = null;
    isBusy = false;

    async created() {
        const periodi = this.periodi = await this.loadData(() => dataProxy.vratiPeriode())();
        periodi.unshift(Period.fromJS({id: '', naziv: '...'}));
        this.periodi = periodi.map(x => ({id: x.id, text: x.naziv}));
        this.columns = [
            [
                {field: 'osoba', title: this.$i18n.t('osoba'), rowspan: 2, align: 'center', valign: 'middle'},
                {field: 'period', title: this.$i18n.t('period'), rowspan: 2, align: 'center', valign: 'middle'},
                {field: 'mesec', title: this.$i18n.t('mesec'), rowspan: 2, align: 'center', valign: 'middle'},
                {field: 'prosecnoVreme', title: this.$i18n.t('prosecnoVreme'), rowspan: 2, align: 'center', valign: 'middle'},
                {field: 'ukunoVremeRada', title: this.$i18n.t('ukupnoRV'), rowspan: 2, align: 'center', valign: 'middle'},
                {field: 'prosecnoVremeSaProduzenjem', title: this.$i18n.t('produzenoVreme'), rowspan: 2, align: 'center', valign: 'middle'},
                {title: this.$i18n.t('nedelja1'), colspan: 2, align: 'center'},
                {title: this.$i18n.t('nedelja2'), colspan: 2, align: 'center'},
                {title: this.$i18n.t('nedelja3'), colspan: 2, align: 'center'},
                {title: this.$i18n.t('nedelja4'), colspan: 2, align: 'center'},
                {title: this.$i18n.t('nedelja5'), colspan: 2, align: 'center'}

            ],
            [
                {field: 'nedelja1.datumPocetka', title: this.$i18n.t('datum'), align: 'center', formatter: formatDate},
                {field: 'nedelja1.vremeRada', title: this.$i18n.t('ukupnoVreme'), align: 'center'},
                {field: 'nedelja2.datumPocetka', title: this.$i18n.t('datum'), align: 'center', formatter: formatDate},
                {field: 'nedelja2.vremeRada', title: this.$i18n.t('ukupnoVreme'), align: 'center'},
                {field: 'nedelja3.datumPocetka', title: this.$i18n.t('datum'), align: 'center', formatter: formatDate},
                {field: 'nedelja3.vremeRada', title: this.$i18n.t('ukupnoVreme'), align: 'center'},
                {field: 'nedelja4.datumPocetka', title: this.$i18n.t('datum'), align: 'center', formatter: formatDate},
                {field: 'nedelja4.vremeRada', title: this.$i18n.t('ukupnoVreme'), align: 'center'},
                {field: 'nedelja5.datumPocetka', title: this.$i18n.t('datum'), align: 'center', formatter: formatDate},
                {field: 'nedelja5.vremeRada', title: this.$i18n.t('ukupnoVreme'), align: 'center'},

            ]
        ];
    }

    async pretraziReferentnePeriode() {
        const isValid = await (<any>this.$refs.observer).validate();
        if (isValid) {
            try {
                this.isBusy = true;
                this.mesecnoRV = await this.loadData(() => dataProxy.vratiMesecnoRadnoVreme(this.izabraniPeriod, this.osobaId))();
            } finally {
                this.isBusy = false;
            }
        }
    }
}
